import { PYRAMID3D_NUMBER_TYPE } from "@visactor/vrender-core";

import { Base3dPicker } from "../common/base-3d-picker";

export class DefaultCanvasPyramid3dPicker extends Base3dPicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "pyramid3d", this.numberType = PYRAMID3D_NUMBER_TYPE, 
        this.themeType = "polygon";
    }
}
//# sourceMappingURL=pyramid3d-picker.js.map
